/**
 * Universal Store — Comandă minimă JS
 * Se activează DOAR cand drawlerul e deschis. Nu modifica DOM-ul la load.
 * v4 — praguri citite din window.usShippingConfig (Theme Editor -> Universal Store: Livrare)
 */
(function() {
  'use strict';

  var CFG = window.usShippingConfig || {};
  var MIN_ORDER      = CFG.minOrder      || 60;
  var SHIP_LOCKER    = CFG.shipLocker    || 22;
  var SHIP_DOMICILIU = CFG.shipDomiciliu || 25;
  var FREE_SHIP      = CFG.freeShip      || 400;

  // Selectori pentru butonul de checkout in drawer
  var CHECKOUT_SELECTORS = [
    'a[href*="/checkout"]',
    'a[href*="checkout.shopify"]',
    'input[name="checkout"]',
    'button[name="checkout"]',
    '.cart__checkout',
    '.ajaxcart__checkout',
    '[data-action="checkout"]',
    'form[action*="/cart"] [type="submit"]',
    '.checkout-btn',
    '.btn-checkout'
  ].join(',');

  function getEffectiveTotal(cartTotalCents) {
    var cartTotal = cartTotalCents / 100;
    var shipping  = cartTotal >= FREE_SHIP ? 0 : SHIP_LOCKER;
    return cartTotal + shipping;
  }

  // Injecteaza butonul 'Continua cumparaturile' la finalul listei de produse
  function injectContinueBtn() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer || cartDrawer.getAttribute('aria-hidden') !== 'false') return;
    var inner = cartDrawer.querySelector('.ajaxcart__inner');
    if (!inner) return;
    if (inner.querySelector('.us-drawer-continue-btn')) return; // deja exista
    var btn = document.createElement('button');
    btn.className = 'us-drawer-continue-btn';
    btn.type = 'button';
    btn.textContent = '← Continuă cumpărăturile';
    btn.addEventListener('click', function() {
      // Inchide drawlerul
      cartDrawer.setAttribute('aria-hidden', 'true');
      var overlay = document.querySelector('.overlay-backdrop.overlay-drawer');
      if (overlay) {
        overlay.classList.remove('is-visible', 'overlay--active', 'active');
      }
      document.body.classList.remove('overflow-hidden', 'drawer-open');
      if (window.ajaxCart && typeof window.ajaxCart.close === 'function') {
        window.ajaxCart.close();
      }
    });
    inner.appendChild(btn);
  }

  function blockCheckout(container) {
    container.querySelectorAll(CHECKOUT_SELECTORS).forEach(function(btn) {
      if (btn.getAttribute('data-us-om-blocked')) return;
      btn.setAttribute('disabled', 'disabled');
      btn.style.opacity = '0.45';
      btn.style.pointerEvents = 'none';
      btn.style.cursor = 'not-allowed';
      btn.setAttribute('data-us-om-blocked', '1');
    });
  }

  function unblockCheckout(container) {
    container.querySelectorAll('[data-us-om-blocked]').forEach(function(btn) {
      btn.removeAttribute('disabled');
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
      btn.style.cursor = '';
      btn.removeAttribute('data-us-om-blocked');
    });
  }

  function updateDrawerMinimum() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer || cartDrawer.getAttribute('aria-hidden') !== 'false') return;

    var container = document.querySelector('#CartContainer');
    if (!container) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartTotal      = cart.total_price / 100;
        var effectiveTotal = getEffectiveTotal(cart.total_price);
        var blocked        = effectiveTotal < MIN_ORDER;
        var remaining      = Math.max(0, MIN_ORDER - effectiveTotal);
        var pct            = Math.min(100, Math.round((effectiveTotal / MIN_ORDER) * 100));

        // Gaseste sau creeaza elementul notificare
        var existing = container.querySelector('.us-om-drawer');
        if (!existing) {
          // Insereaza inainte de footer (ajaxcart__footer)
          var footer = container.querySelector('.ajaxcart__footer');
          if (!footer) {
            // Fallback: insereaza la sfarsitul containerului
            existing = document.createElement('div');
            existing.className = 'us-om-drawer';
            container.appendChild(existing);
          } else {
            existing = document.createElement('div');
            existing.className = 'us-om-drawer';
            footer.parentNode.insertBefore(existing, footer);
          }
        }

        if (blocked) {
          var shipInfo = cartTotal >= FREE_SHIP
            ? '<span class="us-om-ship-free">★ Transport gratuit!</span>'
            : '<span class="us-om-ship-rows">'
                + '<span>&#128230; Locker: <strong>' + SHIP_LOCKER + ' lei</strong></span>'
                + '<span>&#128666; Domiciliu: <strong>' + SHIP_DOMICILIU + ' lei</strong></span>'
              + '</span>';

          existing.innerHTML = [
            '<div class="us-om-notice us-om-notice--blocked">',
              '<div class="us-om-icon">',
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none">',
                  '<circle cx="12" cy="12" r="10" fill="#dc2626"/>',
                  '<path d="M12 7v6" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/>',
                  '<circle cx="12" cy="16.5" r="1.2" fill="#fff"/>',
                '</svg>',
              '</div>',
              '<div class="us-om-text">',
                '<strong>Comandă minimă: ' + MIN_ORDER + ' lei</strong>',
                '<span>Mai adaugă <strong>' + remaining.toFixed(0) + ' lei</strong> produse pentru a comanda.</span>',
                '<span class="us-om-sub">' + shipInfo + '</span>',
              '</div>',
            '</div>',
            '<div class="us-om-progress-wrap" style="margin:8px 0 10px">',
              '<div class="us-om-progress-bar">',
                '<div class="us-om-progress-fill" style="width:' + pct + '%"></div>',
              '</div>',
            '</div>',
          ].join('');

          blockCheckout(container);
        } else {
          var shipNote = cartTotal >= FREE_SHIP
            ? 'transport gratuit!'
            : 'transport: ' + SHIP_LOCKER + ' lei (locker) / ' + SHIP_DOMICILIU + ' lei (domiciliu)';

          existing.innerHTML = [
            '<div class="us-om-notice us-om-notice--ok" style="margin-bottom:10px">',
              '<div class="us-om-icon">',
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none">',
                  '<circle cx="12" cy="12" r="10" fill="#16a34a"/>',
                  '<polyline points="8,12 11,15 16,9" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>',
                '</svg>',
              '</div>',
              '<div class="us-om-text">',
                '<strong>Comandă validă ✓</strong>',
                '<span>Produse: ' + cartTotal.toFixed(0) + ' lei + ' + shipNote + '</span>',
              '</div>',
            '</div>',
          ].join('');

          unblockCheckout(container);
        }

        // Injecteaza butonul continua cumparaturile
        injectContinueBtn();
      })
      .catch(function() {});
  }

  // Stiluri inline
  var style = document.createElement('style');
  style.textContent = [
    '.us-om-notice { display:flex; align-items:flex-start; gap:10px; padding:10px 12px; border-radius:8px; margin-bottom:4px; }',
    '.us-om-notice--blocked { background:#fef2f2; border:1px solid #fecaca; }',
    '.us-om-notice--ok { background:#f0fdf4; border:1px solid #bbf7d0; }',
    '.us-om-icon { flex-shrink:0; padding-top:2px; }',
    '.us-om-text { display:flex; flex-direction:column; gap:2px; font-size:0.8rem; color:#333; }',
    '.us-om-text strong { font-size:0.82rem; }',
    '.us-om-text span { color:#555; }',
    '.us-om-progress-bar { height:6px; background:#e5e7eb; border-radius:3px; overflow:hidden; }',
    '.us-om-progress-fill { height:100%; background:linear-gradient(90deg,#16a34a,#22c55e); border-radius:3px; transition:width 0.4s ease; }',
    '.us-om-ship-rows { display:flex; flex-direction:column; gap:2px; margin-top:3px; }',
    '.us-om-ship-rows span { font-size:0.72rem; color:#555; }',
    '.us-om-ship-free { font-size:0.75rem; color:#16a34a; font-weight:600; margin-top:2px; }',
  ].join('');
  document.head.appendChild(style);

  var cartContainerObs = null;

  function watchCartContainer() {
    var container = document.querySelector('#CartContainer');
    if (!container || cartContainerObs) return;
    // Observa re-render ul continutului cartului (Debutify re-rendereaza innerHTML)
    cartContainerObs = new MutationObserver(function() {
      var cartDrawer = document.getElementById('CartDrawer');
      if (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') {
        setTimeout(updateDrawerMinimum, 150);
      }
    });
    cartContainerObs.observe(container, { childList: true, subtree: true });
  }

  function watchDrawer() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    var drawerObs = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'aria-hidden') {
          if (cartDrawer.getAttribute('aria-hidden') === 'false') {
            // Drawlerul tocmai s-a deschis
            setTimeout(updateDrawerMinimum, 300);
            setTimeout(injectContinueBtn, 500);
            watchCartContainer();
          } else {
            // Drawlerul s-a inchis — curatam
            var container = document.querySelector('#CartContainer');
            if (container) {
              var existing = container.querySelector('.us-om-drawer');
              if (existing) existing.remove();
              unblockCheckout(container);
            }
            if (cartContainerObs) {
              cartContainerObs.disconnect();
              cartContainerObs = null;
            }
          }
        }
      });
    });
    drawerObs.observe(cartDrawer, { attributes: true });

    // Reactioneaza si la update cos cand e deschis
    document.addEventListener('cart:updated',     function() { setTimeout(updateDrawerMinimum, 200); });
    document.addEventListener('ajaxCart:updated', function() { setTimeout(updateDrawerMinimum, 200); });
    // Debutify specific events
    document.addEventListener('ajaxcart:updated', function() { setTimeout(updateDrawerMinimum, 200); });
    document.addEventListener('CartUpdated',      function() { setTimeout(updateDrawerMinimum, 200); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }

})();
